var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-tag"},[_c('RwvArticleList',{attrs:{"tag":_vm.tag}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }